// import Style from '../../../../../component/popup/style.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'

const AddPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, Style, buildings = [], meters = [] }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });

    useEffect(() => {
        console.log("currentData", currentData)
        if (currentData?.id) {
            formik.setFieldValue("month", currentData?.billing_month || "")
            formik.setFieldValue("location_id", currentData?.location_id || "")
            formik.setFieldValue("meter_id", currentData?.meter_id || "")
            // formik.setFieldValue("currentReading", currentData?.current_reading ? currentData?.current_reading?.replaceAll(",", "") : "")
            // formik.setFieldValue("previousReading", currentData?.previous_reading ? currentData?.previous_reading?.replaceAll(",", "") : "")
            formik.setFieldValue("unitsConsumed", currentData?.units_consumed ? currentData?.units_consumed?.replaceAll(",", "") : "")
            
            // formik.setFieldValue("bill_amount", currentData?.total_amount ?? "")
            formik.setFieldValue("bill_amount", currentData?.total_amount ? currentData?.total_amount?.replaceAll("PKR ", "")?.replaceAll(",", "") : "")
            formik.setFieldValue("billDate", currentData?.bill_date ? moment(currentData?.bill_date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("dueDate", currentData?.due_date ? moment(currentData?.due_date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("billPath", currentData?.bill_path || "");
        }
    }, [currentData?.id])

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const validationSchema = yup.object().shape({
        month: yup.string().required('This Field is required'),
        location_id: yup.string().required('This Field is required'),
        meter_id: yup.string().required('This Field is required'),
        bill_amount: yup.string().required('This Field is required'),
        // currentReading: yup.string().required('This Field is required'),
        // previousReading: yup.string().required('This Field is required'),
        unitsConsumed: yup.string().required('This Field is required'),
        billDate: yup.string().required('This Field is required'),
        dueDate: yup.string().required('This Field is required'),
        billPath: yup.string().required('This Field is required')
    });

    const formik = useFormik({
        initialValues: {
            month: "",
            location_id: "",
            meter_id: "",
            // currentReading: "",
            // previousReading: "",
            bill_amount: "",
            billDate: "",
            dueDate: "",
            billPath: "",
            unitsConsumed: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            console.log("Values", values);
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "id": currentData?.id
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "location_id": values.location_id,
                "meter_id": values.meter_id,
                "billing_month": values.month,
                // "previous_reading": values.previousReading,
                // "current_reading": values.currentReading,
                "units_consumed": values.unitsConsumed,
                "total_amount": values.bill_amount,
                "bill_date": values.billDate,
                "due_date": values.dueDate,
                "payment_status": "unpaid",
                "bill_path": values.billPath
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `electricity-bills/update` : `electricity-bills/add`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Month</FormLabel>
                            <input
                                type={'month'}
                                name={'month'}
                                onChange={formik.handleChange}
                                value={formik.values.month}
                                placeholder='Asset Name'
                            />
                            {formik.touched.month && formik.errors.month && (
                                <FeildError>{formik.errors.month}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Building</FormLabel>

                            <SelectSearch
                                name="location_id"
                                placeholder="- Select Building -"
                                onChange={(val) => {
                                    formik.setFieldValue("location_id", val);
                                }}
                                value={formik.values.location_id}
                                options={buildings?.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.location_id && formik.errors.location_id && (
                                <FeildError>{formik.errors.location_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Meter</FormLabel>

                            <SelectSearch
                                name="meter_id"
                                placeholder="- Select Meter -"
                                onChange={(val) => {
                                    formik.setFieldValue("meter_id", val);
                                }}
                                value={formik.values.meter_id}
                                options={meters?.map((el) => ({
                                    label: `${el.remarks} (${el.meter_number})`,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.meter_id && formik.errors.meter_id && (
                                <FeildError>{formik.errors.meter_id}</FeildError>
                            )}
                        </FeildWraper>

                        {/* <FeildWraper>
                            <FormLabel required>Current Reading</FormLabel>
                            <input
                                type={'number'}
                                name={'currentReading'}
                                onChange={formik.handleChange}
                                value={formik.values.currentReading}
                                placeholder='Current Reading'
                            />
                            {formik.touched.currentReading && formik.errors.currentReading && (
                                <FeildError>{formik.errors.currentReading}</FeildError>
                            )}
                        </FeildWraper> */}

                        {/* <FeildWraper>
                            <FormLabel required>Previous Reading</FormLabel>
                            <input
                                type={'number'}
                                name={'previousReading'}
                                onChange={formik.handleChange}
                                value={formik.values.previousReading}
                                placeholder='Previous Reading'
                            />
                            {formik.touched.previousReading && formik.errors.previousReading && (
                                <FeildError>{formik.errors.previousReading}</FeildError>
                            )}
                        </FeildWraper> */}

                        <FeildWraper>
                            <FormLabel required>Consumed Units</FormLabel>
                            <input
                                type={'number'}
                                name={'unitsConsumed'}
                                onChange={formik.handleChange}
                                value={formik.values.unitsConsumed}
                                placeholder='Consumed Units'
                            />
                            {formik.touched.unitsConsumed && formik.errors.unitsConsumed && (
                                <FeildError>{formik.errors.unitsConsumed}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Bill Amount</FormLabel>
                            
                            <input
                                type={'number'}
                                name={'bill_amount'}
                                onChange={formik.handleChange}
                                value={formik.values.bill_amount}
                                placeholder='Bill Amount'
                            />
                            {formik.touched.bill_amount && formik.errors.bill_amount && (
                                <FeildError>{formik.errors.bill_amount}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Bill Date</FormLabel>
                            
                            <input
                                type={'date'}
                                name={'billDate'}
                                onChange={formik.handleChange}
                                value={formik.values.billDate}
                                placeholder='Bill Receipt Number'
                            />
                            {formik.touched.billDate && formik.errors.billDate && (
                                <FeildError>{formik.errors.billDate}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Due Date</FormLabel>
                            
                            <input
                                type={'date'}
                                name={'dueDate'}
                                onChange={formik.handleChange}
                                value={formik.values.dueDate}
                                placeholder='Bill Receipt Number'
                            />
                            {formik.touched.dueDate && formik.errors.dueDate && (
                                <FeildError>{formik.errors.dueDate}</FeildError>
                            )}
                        </FeildWraper>

                        {/* <FeildWraper width='100%'>
                            <FormLabel>Notes</FormLabel>

                            <textarea
                                type={'text'}
                                name={'notes'}
                                onChange={formik.handleChange}
                                value={formik.values.notes}
                                placeholder='notes'
                            />
                            {formik.touched.notes && formik.errors.notes && (
                                <FeildError>{formik.errors.notes}</FeildError>
                            )}
                        </FeildWraper> */}

                        <FeildWraper width='100%'>
                            <FormLabel>Bill Receipt</FormLabel>
                            
                            <FileUploadProgressBar
                                value={formik.values.billPath}
                                onChange={(file) => formik.setFieldValue("billPath", file)}
                                loader={formik.values.billPath}
                            // acceptType="pdf"
                            />
                            {
                                (formik.touched.billPath && Boolean(formik.errors.billPath)) && (
                                    <FeildError>{formik.touched.billPath && formik.errors.billPath}</FeildError>
                                )
                            }
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    {
                        (formik?.values?.assignTo || (currentData?.id && currentData?.status == "Assigned" && formik?.values?.status != "Assigned")) ?
                            <p className='text-red-500 text-[14px]'>{formik?.values?.assignTo ? "If you enter an Assign to Date, the asset remains in stock, it gets assigned and then immediately unassigned from the selected user." : "This action will unassign all users from the asset."}</p>
                            :
                            null
                    }
                    {/* <div className={`${Style.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddPopup
